import { ExtraOptions, Routes } from '@angular/router';

import { SearchCountryComponent } from '../search-country/search-country.component';
import { StepOneComponent } from '../step-one-product-select/step-one.component';
import { StepThreeComponent } from '../step-three/step-three.component';
import { StepFourComponent } from '../step-four/step-four.component';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { StepTwoTravelerDetailsComponent } from '../step-two-traveler-details/step-two-traveler-details.component';
import { TravelInsuranceComponent } from '../staticpages/travel-insurance/travel-insurance.component';
import { FamilyTravelInsuranceComponent } from '../staticpages/family-travel-insurance/family-travel-insurance.component';
import { TravelMedicalInsuranceComponent } from '../staticpages/travel-medical-insurance/travel-medical-insurance.component';
import { CruiseTravelInsuranceComponent } from '../staticpages/cruise-travel-insurance/cruise-travel-insurance.component';
import { WhatsCoveredComponent } from '../staticpages/whats-covered/whats-covered.component';
import { TopCoverComponent } from '../staticpages/top-cover/top-cover.component';
import { EssentialsCoverComponent } from '../staticpages/essentials-cover/essentials-cover.component';
import { BasicsCoverComponent } from '../staticpages/basics-cover/basics-cover.component';
import { DomesticCoverComponent } from '../staticpages/domestic-cover/domestic-cover.component';
import { AnnualMultiTripCoverComponent } from '../staticpages/annual-multi-trip-cover/annual-multi-trip-cover.component';
import { SkiCoverComponent } from '../staticpages/ski-cover/ski-cover.component';
import { ExistingMedicalComponent } from '../staticpages/existing-medical/existing-medical.component';
import { FaqsComponent } from '../staticpages/faqs/faqs.component';
import { EmergencyComponent } from '../staticpages/emergency/emergency.component';
import { HowToClaimComponent } from '../staticpages/how-to-claim/how-to-claim.component';
import { TravelAlertsComponent } from '../staticpages/travel-alerts/travel-alerts.component';
import { CovidFaqsComponent } from '../staticpages/covid-faqs/covid-faqs.component';
import { IsraelComponent } from '../staticpages/israel/israel.component';
import { IsraelFaqsComponent } from '../staticpages/israel-faqs/israel-faqs.component';
import { AboutUsComponent } from '../staticpages/about-us/about-us.component';
import { RefundsComponent } from '../staticpages/refunds/refunds.component';
import { TermsAndConditionsComponent } from '../staticpages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from '../staticpages/privacy-policy/privacy-policy.component';
import { PdsComponent } from '../staticpages/pds/pds.component';
import { WhiteLabelPdsComponent } from '../staticpages/whitelabelpds/whitelabelpds.component';
import { PaymentConfirmationComponent } from '../payment-confirmation/payment-confirmation.component';
import { InformationTemplateComponent } from '../staticpages/information-template/information-template.component';
import { AwardsComponent } from '../../components/homepage/awards/awards.component';
import { ContactUsComponent } from '../staticpages/contact-us/contact-us.component';
import { ReviewPolicyComponent } from '../staticpages/review-policy/review-policy.component';
import { ExpiredQuoteComponent } from '../expired-quote/expired-quote.component';
import { AlfredComponent } from '../staticpages/alfred/alfred.component';
import { MountLewotobiComponent } from '../staticpages/mount-lewotobi/mount-lewotobi.component';
import { DonottravelComponent } from '../staticpages/information/donottravel/donottravel.component';
import { Covid19Component } from '../staticpages/information/covid19/covid19.component';
import { ChinaandirandonottravelComponent } from '../staticpages/information/chinaandirandonottravel/chinaandirandonottravel.component';
import { FijiscyclonesaraiComponent } from '../staticpages/information/fijiscyclonesarai/fijiscyclonesarai.component';
import { HongkongprotestsComponent } from '../staticpages/information/hongkongprotests/hongkongprotests.component';
import { IndonesiasmtagungvolcanoComponent } from '../staticpages/information/indonesiasmtagungvolcano/indonesiasmtagungvolcano.component';
import { VirginairlineComponent } from '../staticpages/information/virginairline/virginairline.component';
import { World2coverawardsComponent } from '../staticpages/information/world2coverawards/world2coverawards.component';
import { MiddleEastConflictComponent } from '../staticpages/middleeastconflict/middleeastconflict.component';
import { WhiteLabelpdsRedirectComponent } from '../staticpages/whitelabelpds/whitelabelpdsredirect.component';

export const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'top', // Add this line to automatically scroll to top on navigation
  anchorScrolling: 'enabled', // Optional, enables scrolling to anchor elements
  scrollOffset: [0, 64], // Optional, [x, y] - Adjust if you have a fixed header and the anchor is covered by the header
};

export const routes: Routes = [
  //policy binding
  { path: '', component: SearchCountryComponent },
  { path: 'product', redirectTo: 'quotes-steps-one' },
  { path: 'quotes-steps-one', component: StepOneComponent },
  { path: 'quotes-steps-two', component: StepTwoTravelerDetailsComponent },
  { path: 'quotes-steps-three', component: StepThreeComponent },
  { path: 'quotes-steps-four', component: StepFourComponent },
  { path: 'payment-confirmation', component: PaymentConfirmationComponent },
  { path: 'error', component: ErrorPageComponent },
  { path: 'error/:status', component: ErrorPageComponent },
  //travel-insurance
  { path: 'travel-insurance', component: TravelInsuranceComponent },
  {
    path: 'family-travel-insurance',
    redirectTo: 'travel-insurance/family-travel-insurance',
  },
  {
    path: 'travel-insurance/family-travel-insurance',
    component: FamilyTravelInsuranceComponent,
  },
  {
    path: 'travel-medical-insurance',
    redirectTo: 'travel-insurance/travel-medical-insurance',
  },
  {
    path: 'travel-insurance/travel-medical-insurance',
    component: TravelMedicalInsuranceComponent,
  },
  {
    path: 'cruise-travel-insurance',
    redirectTo: 'travel-insurance/cruise-travel-insurance',
  },
  {
    path: 'travel-insurance/cruise-travel-insurance',
    component: CruiseTravelInsuranceComponent,
  },
  //whats-covered
  { path: 'whats-covered', component: WhatsCoveredComponent },
  { path: 'top-cover', redirectTo: 'whats-covered/top-cover' },
  { path: 'whats-covered/top-cover', component: TopCoverComponent },
  { path: 'essentials-cover', redirectTo: 'whats-covered/essentials-cover' },
  {
    path: 'whats-covered/essentials-cover',
    component: EssentialsCoverComponent,
  },
  { path: 'basics-cover', redirectTo: 'whats-covered/basics-cover' },
  { path: 'whats-covered/basics-cover', component: BasicsCoverComponent },
  {
    path: 'domestic-cover',
    redirectTo: 'whats-covered/domestic-cover',
  },
  {
    path: 'whats-covered/domestic-cover',
    component: DomesticCoverComponent,
  },
  {
    path: 'annual-multi-trip-cover',
    redirectTo: 'whats-covered/annual-multi-trip-cover',
  },
  {
    path: 'whats-covered/annual-multi-trip-cover',
    component: AnnualMultiTripCoverComponent,
  },
  { path: 'ski-cover', redirectTo: 'whats-covered/ski-cover' },
  { path: 'whats-covered/ski-cover', component: SkiCoverComponent },
  { path: 'existing-medical', redirectTo: 'whats-covered/existing-medical' },
  {
    path: 'whats-covered/existing-medical',
    component: ExistingMedicalComponent,
  },
  //travel-alerts
  { path: 'travel-alerts', component: TravelAlertsComponent },
  { path: 'covid19', redirectTo: 'travel-alerts/covid19' },
  { path: 'travel-alerts/covid19', component: Covid19Component },
  { path: 'covid-faqs', redirectTo: 'travel-alerts/covid19/covid-faqs' },
  { path: 'travel-alerts/covid19/covid-faqs', component: CovidFaqsComponent },
  { path: 'alfred', redirectTo: 'travel-alerts/alfred' },
  { path: 'travel-alerts/alfred', component: AlfredComponent },
  { path: 'mount-lewotobi', redirectTo: 'travel-alerts/mount-lewotobi' },
  { path: 'travel-alerts/mount-lewotobi', component: MountLewotobiComponent },
  {
    path: 'middleeastconflict',
    redirectTo: 'travel-alerts/middleeastconflict',
  },
  { path: 'travel-alerts/middleeastconflict', component: IsraelComponent },
  {
    path: 'middleeastconflict1march2026',
    redirectTo: 'travel-alerts/middleeastconflict1march2026',
  },
  {
    path: 'travel-alerts/middleeastconflict1march2026',
    component: MiddleEastConflictComponent,
  },
  //{ path: 'information/:pageName', redirectTo: 'travel-alerts/:pageName' },
  //{ path: 'travel-alerts/:pageName', component: InformationTemplateComponent },
  { path: 'donottravel', redirectTo: 'travel-alerts/do-not-travel' },
  { path: 'travel-alerts/do-not-travel', component: DonottravelComponent },
  {
    path: 'chinaandirandonottravel',
    redirectTo: 'travel-alerts/china-iran-do-not-travel',
  },
  {
    path: 'travel-alerts/china-iran-do-not-travel',
    component: ChinaandirandonottravelComponent,
  },
  { path: 'fijicyclone', redirectTo: 'travel-alerts/fiji-cyclone-sarai' },
  {
    path: 'travel-alerts/fiji-cyclone-sarai',
    component: FijiscyclonesaraiComponent,
  },
  { path: 'hongkongprotest', redirectTo: 'travel-alerts/hong-kong-protest' },
  {
    path: 'travel-alerts/hong-kong-protest',
    component: HongkongprotestsComponent,
  },
  { path: 'indonesia', redirectTo: 'travel-alerts/indonesia-mt-agung-volcano' },
  {
    path: 'travel-alerts/indonesia-mt-agung-volcano',
    component: IndonesiasmtagungvolcanoComponent,
  },
  { path: 'virginairline', redirectTo: 'travel-alerts/virginairline' },
  { path: 'travel-alerts/virginairline', component: VirginairlineComponent },
  { path: 'israelfaqs', redirectTo: 'travel-alerts/israel-faqs' },
  { path: 'travel-alerts/israel-faqs', component: IsraelFaqsComponent },

  //Others
  { path: 'w2cawards', component: World2coverawardsComponent },
  { path: 'faqs', component: FaqsComponent },
  { path: 'emergency', component: EmergencyComponent },
  { path: 'how-to-claim', component: HowToClaimComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'refunds', component: RefundsComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'review-policy', component: ReviewPolicyComponent },
  { path: 'whitelabelpds', component: WhiteLabelpdsRedirectComponent },
  { path: 'policydocumentation/:labelName', component: WhiteLabelPdsComponent },
  { path: 'pds', redirectTo: 'policydocumentation' },
  { path: 'policydocumentation', component: PdsComponent },
  { path: '**', redirectTo: 'error' },
];
